<script setup>
import HardwareConnectionLost from '@/StoreWeb/components/miscellaneous/conduent-support-reader/hardware/errors/HardwareConnectionLost'
import HardwareNotFound from '@/StoreWeb/components/miscellaneous/conduent-support-reader/hardware/errors/HardwareNotFound'
import HardwareNotRecognized from '@/StoreWeb/components/miscellaneous/conduent-support-reader/hardware/errors/HardwareNotRecognized'
import config from 'config'
import { computed, onMounted, onUnmounted, ref } from 'vue'
import { useI18n } from 'vue-i18n'
import { useStore } from 'vuex'

const emit = defineEmits(['descriptionUpdated', 'componentUpdated', 'hardwareReady', 'stateUpdated'])

const store = useStore()
const { t } = useI18n()

const hardwareLaunchingAttempted = ref(false)

const informationDuration = 2000

const debugInformationsDisplay = computed(() => store.state.debuggingModule.debugInformationsDisplay)

function cleanStep () {
    emit('stateUpdated', '')
    emit('descriptionUpdated', '')
    emit('componentUpdated', null)
}

/* ------------------------------------------------------------- */
/*                         DETECT READER                         */
/* ------------------------------------------------------------- */
function detectReader () {
    cleanStep()
    emit('stateUpdated', 'loading')
    emit('descriptionUpdated', t('card_reader:detect_reader:detect_in_progress:message'))

    window.detectReader()
}

function onDetectReaderHandler (event) {
    if (debugInformationsDisplay.value > 1) {
        // eslint-disable-next-line
        console.log(event.type, event.detail)
    }

    if (event.detail.response === -1) {
        emit('stateUpdated', 'error')
        emit('componentUpdated', HardwareConnectionLost)
    }
}

function onEndDetectReaderHandler (event) {
    cleanStep()

    if (debugInformationsDisplay.value > 1) {
        // eslint-disable-next-line
        console.log(event.type, event.detail)
    }

    if (event.detail.response >= 1) {
        emit('descriptionUpdated', t('card_reader:detect_reader:detection:success:message'))
        getReaderName()
    } else {
        emit('stateUpdated', 'error')
        emit('componentUpdated', hardwareLaunchingAttempted.value ? HardwareNotRecognized : HardwareNotFound)
        hardwareLaunchingAttempted.value = true
    }
}

function getReaderName () {
    emit('stateUpdated', 'loading')
    emit('descriptionUpdated', t('card_reader:detect_reader:identification_in_progress:message'))
    window.GetReaderName()
}

function onGetReaderNameHandler (event) {
    if (debugInformationsDisplay.value > 1) {
        // eslint-disable-next-line
        console.log(event.type, event.detail)
    }

    if (event.detail.response === -1) {
        emit('stateUpdated', 'error')
        emit('componentUpdated', HardwareConnectionLost)
    }
}

function onEndGetReaderNameHandler (event) {
    cleanStep()

    if (debugInformationsDisplay.value > 1) {
        // eslint-disable-next-line
        console.log(event.type, event.detail)
    }

    emit('descriptionUpdated', t('card_reader:detect_reader:get_reader_name:success:message').replace('%readerName%', event.detail.response))

    // 2s is necessary here to show to the user that the plugin is ready
    setTimeout(() => {
        emit('hardwareReady')
    }, informationDuration)
}

/* ------------------------------------------------------------- */
/*                     MOUNTED / UNMOUNTED                       */
/* ------------------------------------------------------------- */
onMounted(() => {
    window.conduentMobilitySolutionsUrl = config.support_reader.conduent_mobility_solutions_url
    document.body.addEventListener('card-reader-detect-reader', onDetectReaderHandler)
    document.body.addEventListener('card-reader-end-detect-reader', onEndDetectReaderHandler)
    document.body.addEventListener('card-reader-get-reader-name', onGetReaderNameHandler)
    document.body.addEventListener('card-reader-end-get-reader-name', onEndGetReaderNameHandler)
})

onUnmounted(() => {
    document.body.removeEventListener('card-reader-detect-reader', onDetectReaderHandler)
    document.body.removeEventListener('card-reader-end-detect-reader', onEndDetectReaderHandler)
    document.body.removeEventListener('card-reader-get-reader-name', onGetReaderNameHandler)
    document.body.removeEventListener('card-reader-end-get-reader-name', onEndGetReaderNameHandler)
})

/* ------------------------------------------------------------- */
/*                        EXPOSED METHODS                        */
/* ------------------------------------------------------------- */
defineExpose({ detectReader })
</script>
